import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, DatePicker, Form, Input, InputNumber, Popconfirm } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import ComingSoonModel from '../../api/models/coming-soon.model';
import FaIcon from '../../components/global/fa-icon/fa-icon';
import MoviePicker from '../../components/movie-picker/movie-picker.component';
import MoviePosterImage from '../../components/movie-poster-image/movie-poster-image.component';



class ComingSoonEditView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    let id = _.get(this, 'props.match.params.id', null);
    let movieId = _.get(this, 'props.match.params.movieId', null);
    // console.log('csev params: ', JSON.stringify(this.props, null, 2));

    this.state = {
      loaded: false,
      saving: false,
      id: id,
      movieId: movieId,
      data: null,
    };

    this.onMovieChanged = this.onMovieChanged.bind(this);
    this.onDateChanged = this.onDateChanged.bind(this);
    this.onDateLabelChanged = this.onDateLabelChanged.bind(this);
    this.onSortIndexChanged = this.onSortIndexChanged.bind(this);
    this.onCommentsChanged = this.onCommentsChanged.bind(this);
    this.onManagerNotesChanged = this.onManagerNotesChanged.bind(this);

    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onDeleteClicked = this.onDeleteClicked.bind(this);

    setTimeout(() => {
      this.invalidateData();
    });
  }

  async invalidateData(forceUpdate = false) {
    let id = this.state.id || null;
    let movieId = this.state.movieId || null;

    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, id)) {
      return false;
    }
    this.prevQuery = id;

    if (id) {
      let res = await api.comingSoon.get(id);
      let item = _.get(res, 'data') || {};

      if (item.movie_id) {
        let resMovie = await api.movies.get(item.movie_id);
        item.movie = _.get(resMovie, 'data') || {};
      }

      this.setState({ loaded: true, data: item });
      return true;
    } else {
      let item = new ComingSoonModel();

      if (movieId) {
        let resMovie = await api.movies.get(movieId);
        let movie = _.get(resMovie, 'data') || null;
        if (movie) {
          item.movie = movie;
          item.movie_id = _.get(movie, 'id', movieId);

          // determine best release date that is in the future
          let releaseDate = movie.releaseDateMomentValue;
          let nextStartDate = moment().startOf('isoWeek').day('friday');
          if (releaseDate && releaseDate.isAfter(nextStartDate)) {
            nextStartDate = releaseDate;
          }
          item.dateMomentValue = nextStartDate;
        }
      }

      this.setState({ loaded: true, data: item });
      return true;
    }
  }

  isAddMode() {
    return !this.state.id;
  }

  isEditMode() {
    return !!this.state.id;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  onMovieChanged(movie) {
    let movieId = _.get(movie, 'id') || null;
    let data = this.state.data;
    data.movie_id = movieId;
    data.movie = movie;

    if (!data.date && movie.releaseDateMomentValue) {
      data.date = movie.releaseDateMomentValue;
    }

    this.setState({ data, movieId });
  }

  onDateChanged(date, dateString) {
    let data = this.state.data;
    data.dateMomentValue = date;
    this.setState({ data });
  }

    onDateLabelChanged(e) {
    let value = this._getTargetStringValue(e, false);
    let data = this.state.data;
    data.date_label = value;
    this.setState({ data });
  }

  onSortIndexChanged(value) {
    let data = this.state.data;
    data.sortIndexIntValue = value;
    this.setState({ data });
  }

  onCommentsChanged(e) {
    let value = this._getTargetStringValue(e, false);
    let data = this.state.data;
    data.comments = value;
    this.setState({ data });
  }

  onManagerNotesChanged(e) {
    let value = this._getTargetStringValue(e, false);
    let data = this.state.data;
    data.manager_notes = value;
    this.setState({ data });
  }

  onSaveClicked(e) {

    // remove the transient movie relation
    let modelData = _.cloneDeep(this.state.data);
    delete modelData.movie;

    this.setState({ loaded: false, saving: true }, () => {
      api.comingSoon.save(modelData.id, modelData).then(res => {
        let newId = _.get(res, 'data.id') || null;
        if (this.isAddMode() && newId) {
          this.props.history.push('/coming-soon/edit/' + newId);
        }
        this.setState({ id: newId, loaded: false, saving: false }, () => {
          this.invalidateData(true);
        });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/coming-soon');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  onDeleteClicked(e) {
    let modelData = _.cloneDeep(this.state.data);
    this.setState({ loaded: false, saving: true }, () => {
      api.comingSoon.remove(modelData.id).then(res => {
        this.props.history.push('/coming-soon');
      });
    });
  }

  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let canDelete = !!id;

    let title = id? ('Edit Coming Soon ' + id): 'Add Coming Soon';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions">
        { canDelete? (
          <Popconfirm
            title="Are you sure you want to delete this coming soon item?"
            okText="Yes"
            cancelText="No"
            onConfirm={this.onDeleteClicked}>
            <Button type="danger" size="large" icon={<FaIcon icon="fa-trash" />}>Delete</Button>
          </Popconfirm>
        ) : null }
        <div className="ml-3">&nbsp;</div>
        <Button type="default" size="large" icon={<FaIcon icon="fa-times"/>} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check"/>} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );

    return (
      <div className="coming-soon-edit-view mx-auto" >
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { (!this.state.loaded)? <LoadingSpinner />: null }

            { (this.state.loaded)? this.renderEditArea(): null }

            { (false && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </Card>
      </div>
    );
  }

  renderEditArea() {
    let data = this.state.data;
    let movie = (data && data.movie) || {};

    return (
      <Form className="edit-coming-soon-content" layout="vertical">

        <div className="poster-area text-center center">
          <MoviePosterImage movie={movie} />
          <div className="movie-info center row">
            { movie? (
              <React.Fragment>
                <div className="col-lg-6 col-sm-12 col-12"><span className="label">Movie ID: </span>{movie?.id}</div>
                <div className="col-lg-6 col-sm-12 col-12"><span className="label">Rating: </span>{movie?.rating}</div>
                <div className="col-lg-6 col-sm-12 col-12"><span className="label">Duration: </span>{this.movieHelper.formatDurationValue(movie?.durationMinsIntValue)}</div>
                <div className="col-lg-6 col-sm-12 col-12"><span className="label">Is 3D: </span>{movie?.is3DBooleanValue? 'Yes': 'No'}</div>
                <div className="col-12"><span className="label">Release Date: </span>{this.movieHelper.formatLongDateValue(movie?.releaseDateMomentValue)}</div>
              </React.Fragment>
            ): null }
          </div>
        </div>
        <div className="details-area container-fluid">

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Movie Title" colon={false}>
                <MoviePicker selectedMovieId={data.movie_id} onSelectedMovieChanged={this.onMovieChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 col-12">
              <Form.Item label="Expected Date" colon={false}>
                <DatePicker
                  className="fillx"
                  format={'ddd M/D/YYYY'}
                  allowClear={false}
                  value={data.dateMomentValue}
                  onChange={this.onDateChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Optional Override Date Label" colon={false}>
                <Input className="fillx" value={data.date_label} onChange={this.onDateLabelChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Sort Order" colon={false}>
                <InputNumber className="fillx" min={0} max={999} disabled={data.archivedBooleanValue} value={data.sortIndexIntValue} onChange={this.onSortIndexChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Comments" colon={false}>
                <Input.TextArea rows={3} value={data.comments} onChange={this.onCommentsChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Optional Manager Notes" colon={false}>
                <Input.TextArea rows={3} value={data.manager_notes} onChange={this.onManagerNotesChanged} />
              </Form.Item>
            </div>
          </div>

        </div>
      </Form>
    );
  }

  renderJsonData() {
    return (
      <pre>{ JSON.stringify(this.state.data, null, 2) }</pre>
    );
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ComingSoonEditView));

